import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Menu } from 'src/app/mds/settings/models/menu';
import { MenuService } from 'src/app/mds/settings/services/menu.service';
import { Breadcrump } from '../../models/breadcrump';
import { PageHeader } from '../../models/page-header';
import { ConfigService, CoreSaveService, FieldType, ICommonMessage, MessageService } from '@gbs-platform-client/fwk-core';

@Component({
  selector: 'pageheader',
  templateUrl: './pageheader.component.html',
  styleUrls: ['./pageheader.component.css']
})
export class PageheaderComponent implements OnInit {
  @Input() entity !: PageHeader;
  menuList: Array<Breadcrump> = [];
  currentUrl = "";
  defaultRowsCount: number;

  constructor(private router: Router,
    private configService: ConfigService,
    private menuService: MenuService) {
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    router.events.subscribe((event: any) => {
      if (event.url != undefined && event.url != null && this.currentUrl != event.url) {
        this.currentUrl = event.url;
        this.menuService.getMenuDetailsByLink(event.url).subscribe((breadcrump: string) => {
          this.menuList = JSON.parse(breadcrump);
        });
      }
    });
  }

  ngOnInit(): void {
  }

  navigateToLink(menu: Breadcrump) {
    if (menu.Link === "/landingpage/landing-menu") {
      this.router.navigate(['landingpage/landing-menu']);
    }
    else {
      this.router.navigate([menu.Link]);
    }
  }
  homeMenu() {
    this.router.navigate(['landingpage/landing-menu']);
  }
}
